import React from "react";

const TextTruncate = ({ children, clamp = 3 }) => {
  const style = {
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: clamp,
    WebkitBoxOrient: "vertical",
    textOverflow: "ellipsis",
  };

  return <div style={style}>{children}</div>;
};

export default TextTruncate;
